<template>
    <Header></Header>
    <Left></Left>
    <section class="container flex _column">
        <template v-for="sector in state.sectorList">
            <template v-if="sector.key === 'banner'">
                <div class="blue_box folding_box" :class="isShow.isShowBanner ? 'open' : ''">
                    <div class="box_tit _flex" @click="isShow.isShowBanner = !isShow.isShowBanner">
                        <div class="_flex">
                            <button type="button" class="move_up" @click.stop="changeOrder(sector, 0)"><img src="img/up_icon.png" alt="" /></button>
                            <button type="button" class="move_down" @click.stop="changeOrder(sector, 1)">
                                <img src="img/down_icon.png" alt="" />
                            </button>
                            <h2>배너</h2>
                        </div>
                        <button type="button" class="open_btn icon_wrap">
                            <img src="img/more_icon.png" alt="더보기" />
                        </button>
                    </div>
                    <BannerForMainpage v-if="isShow.isShowBanner"></BannerForMainpage>
                </div>
            </template>
            <template v-if="sector.key === 'ad'">
                <div class="blue_box folding_box not_fold">
                    <div class="box_tit _flex">
                        <div class="_flex">
                            <button type="button" class="move_up" @click.stop="changeOrder(sector, 0)"><img src="img/up_icon.png" alt="" /></button>
                            <button type="button" class="move_down" @click.stop="changeOrder(sector, 1)">
                                <img src="img/down_icon.png" alt="" />
                            </button>
                            <h2>성매매 업소, 알선광고 제보</h2>
                        </div>
                    </div>
                </div>
            </template>
            <template v-if="sector.key === 'statics'">
                <div class="blue_box folding_box" :class="isShow.isShowReport ? 'open' : ''">
                    <div class="box_tit _flex" @click="isShow.isShowReport = !isShow.isShowReport">
                        <div class="_flex">
                            <button type="button" class="move_up" @click.stop="changeOrder(sector, 0)"><img src="img/up_icon.png" alt="" /></button>
                            <button type="button" class="move_down" @click.stop="changeOrder(sector, 1)">
                                <img src="img/down_icon.png" alt="" />
                            </button>
                            <h2>시민과 함께 만든 변화</h2>
                        </div>
                        <button type="button" class="open_btn icon_wrap">
                            <img src="img/more_icon.png" alt="더보기" />
                        </button>
                    </div>
                    <div class="fordable change_setting">
                        <div class="_flex" v-if="isShow.isShowReport">
                            <div>
                                <span class="con_tit">기간설정</span>
                                <div class="select_date_wrap">
                                    <div class="select_date">
                                        <input type="date" v-model="mainViewInfo.date_main.value" @change="updateMainView(mainViewInfo.date_main)" />
                                    </div>
                                </div>
                                까지
                            </div>
                            <div>
                                <span class="con_tit">전체 시민제보</span>
                                <div class="con_con">
                                    {{ mainViewInfo.cnt_report.value ? CommonUtils.numberFormat(mainViewInfo.cnt_report.value) : "" }} 건
                                </div>
                            </div>
                            <div>
                                <span class="con_tit">신고/ 고발</span>
                                <div class="con_con">
                                    <input
                                        type="text"
                                        v-model="mainViewInfo.cnt_citizen_report.value"
                                        @change="updateMainView(mainViewInfo.cnt_citizen_report)"
                                    />
                                    건
                                </div>
                            </div>
                            <div>
                                <span class="con_tit">함께한 시민 수</span>
                                <div class="con_con">
                                    {{ mainViewInfo.cnt_citizen.value ? CommonUtils.numberFormat(mainViewInfo.cnt_citizen.value) : "" }} 명
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-if="sector.key === 'board_entire'">
                <div class="blue_box folding_box" :class="isShow.isShowActive ? 'open' : ''">
                    <div class="box_tit _flex" @click="isShow.isShowActive = !isShow.isShowActive">
                        <div class="_flex">
                            <button type="button" class="move_up" @click.stop="changeOrder(sector, 0)"><img src="img/up_icon.png" alt="" /></button>
                            <button type="button" class="move_down" @click.stop="changeOrder(sector, 1)">
                                <img src="img/down_icon.png" alt="" />
                            </button>
                            <h2>우리 함께 참여해요</h2>
                        </div>
                        <button type="button" class="open_btn icon_wrap">
                            <img src="img/more_icon.png" alt="더보기" />
                        </button>
                    </div>
                    <BoardEntireForMainpage v-if="isShow.isShowActive"></BoardEntireForMainpage>
                </div>
            </template>
            <template v-if="sector.key === 'board_news'">
                <div class="blue_box folding_box" :class="isShow.isShowGamsi ? 'open' : ''">
                    <div class="box_tit _flex" @click="isShow.isShowGamsi = !isShow.isShowGamsi">
                        <div class="_flex">
                            <button type="button" class="move_up" @click.stop="changeOrder(sector, 0)"><img src="img/up_icon.png" alt="" /></button>
                            <button type="button" class="move_down" @click.stop="changeOrder(sector, 1)">
                                <img src="img/down_icon.png" alt="" />
                            </button>
                            <h2>감시소식</h2>
                        </div>
                        <button type="button" class="open_btn icon_wrap">
                            <img src="img/more_icon.png" alt="더보기" />
                        </button>
                    </div>
                    <BoardGamsiForMainpage v-if="isShow.isShowGamsi"></BoardGamsiForMainpage>
                </div>
            </template>
            <template v-if="sector.key === 'subscribe'">
                <div class="blue_box folding_box not_fold">
                    <div class="box_tit _flex">
                        <div class="_flex">
                            <button type="button" class="move_up" @click.stop="changeOrder(sector, 0)"><img src="img/up_icon.png" alt="" /></button>
                            <button type="button" class="move_down" @click.stop="changeOrder(sector, 1)">
                                <img src="img/down_icon.png" alt="" />
                            </button>
                            <h2>뉴스레터 구독하기</h2>
                        </div>
                    </div>
                </div>
            </template>
        </template>
        <div class="line"></div>
        <div class="blue_box folding_box" :class="isShow.isShowBannerPopup ? 'open' : ''">
            <div class="box_tit _flex" @click="isShow.isShowBannerPopup = !isShow.isShowBannerPopup">
                <div class="_flex">
                    <h2>팝업 배너</h2>
                </div>
                <button type="button" class="open_btn icon_wrap">
                    <img src="img/more_icon.png" alt="더보기" />
                </button>
            </div>
            <BannerPopupForMainpage v-if="isShow.isShowBannerPopup"></BannerPopupForMainpage>
        </div>

        <div class="blue_box folding_box" :class="isShow.isShowFooter ? 'open' : ''">
            <div class="box_tit _flex" @click="isShow.isShowFooter = !isShow.isShowFooter">
                <div class="_flex">
                    <h2>푸터</h2>
                </div>
                <button type="button" class="open_btn icon_wrap">
                    <img src="img/more_icon.png" alt="더보기" />
                </button>
            </div>
            <div class="fordable footer_setting">
                <div class="agree_edit_wrap _flex">
                    <div>
                        서비스 이용약관
                        <button type="button" class="table_btn _blue" @click="agreeFormModal(2)">수정</button>
                    </div>
                    <div>
                        개인정보 처리 방침
                        <button type="button" class="table_btn _blue" @click="agreeFormModal(1)">수정</button>
                    </div>
                </div>
                <!-- <div class="sch_condition_wrap _right">
                    <button type="button" class="table_btn _gray">저장</button>
                    입력창 클릭시: 파란색버튼으로 _gray클래스를 _blue로 변경
                </div> -->
                <ul v-if="isShow.isShowFooter">
                    <li>
                        <label for="add" class="con_tit">{{ mainViewInfo.address.name }}</label>
                        <input type="text" id="add" v-model="mainViewInfo.address.value" @change="updateMainView(mainViewInfo.address)" />
                    </li>
                    <li>
                        <label for="call" class="con_tit">{{ mainViewInfo.phone.name }}</label>
                        <input type="text" id="call" v-model="mainViewInfo.phone.value" @change="updateMainView(mainViewInfo.phone)" />
                    </li>
                    <li>
                        <label for="fax" class="con_tit">{{ mainViewInfo.fax.name }}</label>
                        <input type="text" id="fax" v-model="mainViewInfo.fax.value" @change="updateMainView(mainViewInfo.fax)" />
                    </li>
                    <li>
                        <label for="email" class="con_tit">{{ mainViewInfo.email.name }}</label>
                        <input type="text" id="email" v-model="mainViewInfo.email.value" @change="updateMainView(mainViewInfo.email)" />
                    </li>
                    <li>
                        <textarea
                            name=""
                            id=""
                            placeholder="추가하고 싶은 내용을 입력하세요."
                            v-model="mainViewInfo.footer.value"
                            @change="updateMainView(mainViewInfo.footer)"
                        ></textarea>
                    </li>
                </ul>
            </div>
        </div>
    </section>

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>

    <!-- :data="mainViewInfo.data" -->
    <AgreeFormModal
        v-if="state.isShowAgreeFormModal"
        :gubun="mainViewInfo.gubun"
        :data="mainViewInfo.data"
        @close="state.isShowAgreeFormModal = false"
        @callback="updateMainView"
    ></AgreeFormModal>
</template>
<script lang="ts" config>
    import {
        userStore,
        globalStore,
        reactive,
        watch,
        apiService,
        onMounted,
        router,
        Header,
        Left,
        ModalDefault,
        ModalPopup,
        types,
        onBeforeUnmount,
        getMessageByCode,
        PageBtn,
        AgreeFormModal,
        CommonUtils,
        returnCode,
        BannerForMainpage,
        BannerPopupForMainpage,
        BoardEntireForMainpage,
        BoardGamsiForMainpage,
    } from "@/BaseComponent";

    export default {
        props: {},
        components: {
            Header,
            Left,
            ModalDefault,

            AgreeFormModal,

            BannerForMainpage,
            BannerPopupForMainpage,
            BoardEntireForMainpage,
            BoardGamsiForMainpage,
        },
        setup() {
            const global = globalStore();
            const user = userStore();

            const state = reactive({
                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                sectorList: [] as Array<types.MainSectorVOForApi>,
                mainViewList: [] as Array<types.ResMainViewList>,

                isShowAgreeFormModal: false as boolean,
            });

            const mainViewInfo = reactive({
                address: [] as any,
                footer: [] as any,
                phone: [] as any,
                cnt_citizen: [] as any,
                cnt_citizen_report: [] as any,
                cnt_report: [] as any,
                date_main: {} as any,
                privacy_terms: [] as any,
                fax: [] as any,
                email: [] as any,
                use_terms: [] as any,

                isUserTerms: false as boolean,
                isPrivacyTerms: false as boolean,

                gubun: 0 as number,
                data: "" as string,
            });

            const isShow = reactive({
                isShowReport: false as boolean,
                isShowBanner: false as boolean,
                isShowGamsi: false as boolean,
                isShowActive: false as boolean,
                isShowBannerPopup: false as boolean,
                isShowFooter: false as boolean,
            });

            onMounted(() => {
                global.$reset();
                getMainSector();

                getMainViewList();
            });

            onBeforeUnmount(() => {});

            const closeModal = () => {
                state.isShowModal = false;
            };

            const callBackModal = async (param: any) => {
                if (param.action === "confirm") {
                }
            };

            const getMainSector = async () => {
                const res: types.ResMainSector = await apiService.mainSector.list();
                if (res.returnCode === 0) {
                    state.sectorList = res.list;
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const changeOrder = async (sector: types.MainSectorVOForApi, arrow: number) => {
                let order = sector.order;

                if (arrow === 0 && order !== 1) {
                    order = order - 1;
                } else if (arrow === 1 && order !== 6) {
                    order = order + 1;
                }

                const param: types.ReqMainSectorForOrder = {
                    key: sector.key,
                    order: order,
                };
                const res: types.BaseResponse = await apiService.mainSector.modify(param);
                if (res.returnCode === 0) {
                    getMainSector();
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const getMainViewList = async () => {
                const res = await apiService.mainView.list();

                if (res.returnCode === 0) {
                    // state.mainViewList = res.data;
                    mainViewInfo.address = res.data.address;
                    mainViewInfo.footer = res.data.footer;
                    mainViewInfo.phone = res.data.phone;
                    mainViewInfo.cnt_citizen = res.data.cnt_citizen;
                    mainViewInfo.cnt_citizen_report = res.data.cnt_citizen_report;
                    mainViewInfo.cnt_report = res.data.cnt_report;
                    mainViewInfo.date_main = res.data.date_main;

                    mainViewInfo.privacy_terms = res.data.privacy_terms;
                    mainViewInfo.fax = res.data.fax;
                    mainViewInfo.email = res.data.email;
                    mainViewInfo.use_terms = res.data.use_terms;
                }
            };

            const updateMainView = async (item: types.ReqMainView) => {
                const res = await apiService.mainView.modify(item);
                if (res.returnCode === 0) {
                    getMainViewList();
                    state.isShowAgreeFormModal = false;
                }
            };

            const agreeFormModal = async (gubun: number) => {
                mainViewInfo.gubun = gubun;
                mainViewInfo.data = "";
                if (gubun === 1) {
                    // 개인정보처리방침
                    mainViewInfo.data = mainViewInfo.privacy_terms.value;
                } else {
                    mainViewInfo.data = mainViewInfo.use_terms.value;
                }
                state.isShowAgreeFormModal = true;
            };

            return {
                state,
                isShow,
                user,
                router,
                closeModal,
                callBackModal,
                types,
                global,
                changeOrder,
                agreeFormModal,
                mainViewInfo,
                CommonUtils,
                updateMainView,
            };
        },
    };
</script>
